import styled from '@emotion/styled';
import { Box } from '@mui/system';
import Typography from 'components/Typography/Typography';
import { theme, palette } from 'theme';
import pxToEm from 'theme/pxToEm';

export const Wrapper = styled.div`
  position: relative;
`;

export const Header = styled(Box)`
  display: flex;
  margin-top: ${pxToEm(8)};
  padding: ${pxToEm(12)} 0 ${pxToEm(12)};
  gap: ${pxToEm(20)};
  justify-content: space-between;
  position: sticky;
  z-index: 6;

  ${theme.breakpoints.down('md')} {
    position: static;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 100vw;
    height: 100%;
    background: ${palette.common.white};
    z-index: -1;
    transform: translateX(-50%);
  }

  ${theme.breakpoints.down('md')} {
    flex-direction: column;
    gap: ${pxToEm(16)};
    margin: ${pxToEm(4)} 0 ${pxToEm(8)};
  }
`;

export const SwitchViewMode = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${pxToEm(12)};
  margin-left: auto;
`;

export const SwitchTitle = styled(Typography)``;

export const EmptyState = styled(Typography)`
  text-align: center;
  margin-top: ${pxToEm(16)};
`;
